import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { ProgressLoaderComponent } from '../common/progress-loader/progress-loader.component'
import { TranslatePipe } from '@ngx-translate/core'
import { FileUploadComponent } from '../file-upload/file-upload.component'
import { DocumentUploadInfo } from '../utils'
import { MAX_AGENDA_SIZE_IN_BYTES } from '../call-document-upload/call-document-upload.component'
import { TemplateSourceType } from '../calls.service'

@Component({
  selector: 'app-template-source-picker',
  standalone: true,
  imports: [MatIconModule, ProgressLoaderComponent, TranslatePipe, FileUploadComponent],
  templateUrl: './template-source-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './template-source-picker.component.scss',
})
export class TemplateSourcePickerComponent {
  @Input()
  canEdit: boolean = true
  @Input()
  maxAgendaSize: number = MAX_AGENDA_SIZE_IN_BYTES
  @Input()
  isImporting: boolean = false
  @Input()
  hasAgendaUploaded: boolean = false
  @Input()
  uploadedFileName: string | null = null
  @Input()
  templateSourceType: TemplateSourceType | null = null
  @Input()
  requiresConfirmation: boolean = false

  @Output()
  agendaFileChange = new EventEmitter<DocumentUploadInfo>()
  @Output()
  confirmationRequested = new EventEmitter<void>()
  @Output()
  createNewClicked = new EventEmitter<void>()
  @Output()
  loadSavedClicked = new EventEmitter<void>()

  @ViewChild('fileUpload')
  fileUploadComponent: FileUploadComponent | undefined

  isDragging = false

  get isUploadInProgress(): boolean {
    return this.isImporting || (this.fileUploadComponent?.isUploading ?? false)
  }

  onUploadCardClick(): void {
    if (this.fileUploadComponent !== undefined) {
      this.fileUploadComponent.openFileDialog()
    }
  }

  openFileDialog(): void {
    if (this.fileUploadComponent !== undefined) {
      this.fileUploadComponent.openFileDialog()
    }
  }

  onFileChange(documentUploadInfo: DocumentUploadInfo | null): void {
    if (documentUploadInfo !== null) {
      this.agendaFileChange.emit(documentUploadInfo)
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.isDragging = true
  }

  onDragLeave(): void {
    this.isDragging = false
  }

  onDrop(event: DragEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.isDragging = false
    const files = event.dataTransfer?.files ?? null
    if (files !== null && files.length > 0 && this.fileUploadComponent !== undefined) {
      this.fileUploadComponent.fileInputChanged({ target: { files } })
    }
  }
}
